<template>
  <div
    id="app"
    class="app">
    <aside class="menu">
      <p class="menu-label">
        Base
      </p>
      <ul class="menu-list">
        <li>
          <router-link to="/">
            Home
          </router-link>
        </li>
      </ul>
      <p class="menu-label">
        MWP Headers
      </p>
      <ul class="menu-list">
        <li>
          <router-link to="/headers">
            Headers
          </router-link>
        </li>
        <li>
          <router-link to="/create/header">
            Create Header
          </router-link>
        </li>
      </ul>
      <p class="menu-label">
        Publishing
      </p>
      <ul class="menu-list">
        <li>
          <router-link to="/publish/headers">
            Publish headers
          </router-link>
        </li>
      </ul>
      <p class="menu-label">
        User
      </p>
      <ul class="menu-list">
        <b-button
          class="log-out"
          @click="logOut">
          Log-out
        </b-button>
      </ul>
    </aside>
    <div class="main-container">
      <router-view />
    </div>
  </div>
</template>
<script>
import { firebase } from "./firebase";

export default {
  name: "App",
  methods: {
    logOut() {
      // this.$store.dispatch("logOut", {
      //   email: this.email,
      //   password: this.password
      // });
      firebase.auth().signOut();
    }
  }
};
</script>


<style lang="scss">
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
  padding-top: 1rem;
}

.app {
  display: flex;
  flex-wrap: wrap;
  @media screen and (min-width: 768px) {
    flex-wrap: nowrap;
  }
}

.main-container {
  flex-grow: 1;
  max-width: calc(100% - 230px);
}

.menu {
  width: 100%;
  text-align: left;
  padding: 0 1rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid grey;
  margin-bottom: 2rem;
  @media screen and (min-width: 768px) {
    min-width: 230px;
    width: 230px;
    border: none;
  }
}

.input-section {
  max-width: 600px;
  padding-bottom: 5rem;
}

main.content {
  display: flex;
  justify-content: space-between;

  .input-section {
    min-width: 400px;
    margin-right: 5rem;
  }

  .preview {
    flex-grow: 1;
    padding: 0rem 2rem 1rem;
  }
}

h2 {
  font-size: 2rem !important;
}

.info-icon {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: blue;
  color: #fff;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  cursor: pointer;
}

.b-tooltip {
  float: right;
}

.b-table {
  max-width: 1000px;
}

/* // global header styles from mwp */
.tablet.header {
  max-width: 750px;
}

.mobile.header {
  max-width: 360px;
}

.header-content {
  width: 100%;
  padding-bottom: 59.72%;
  background-size: cover;
  position: relative;

  .top-story-overlay {
    height: 100%;
    width: 100%;
    position: absolute;
    background: linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0.4) 0%,
      rgba(0, 0, 0, 0.2) 20%,
      rgba(0, 0, 0, 0) 30%,
      rgba(0, 0, 0, 0) 100%
    );
  }
  .bot-story-overlay {
    height: 100%;
    width: 100%;
    position: absolute;
    background: linear-gradient(
      to top,
      rgba(0, 0, 0, 0.6) 0%,
      rgba(0, 0, 0, 0.3) 30%,
      rgba(0, 0, 0, 0) 45%,
      rgba(0, 0, 0, 0) 100%
    );
  }
}

.tablet .header-content {
  height: 448px;
  margin: 0 auto;
  padding-bottom: 0;
  .top-story-overlay {
    background: linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0.3) 0%,
      rgba(0, 0, 0, 0.2) 15%,
      rgba(0, 0, 0, 0) 25%,
      rgba(0, 0, 0, 0) 100%
    );
  }
  .bot-story-overlay {
    height: 100%;
    width: 100%;
    position: absolute;
    background: linear-gradient(
      to top,
      rgba(0, 0, 0, 0.6) 0%,
      rgba(0, 0, 0, 0.3) 20%,
      rgba(0, 0, 0, 0) 35%,
      rgba(0, 0, 0, 0) 100%
    );
  }
}

.cta-btn-header {
  display: flex;
  position: absolute;
  bottom: 1.6rem;
  left: 50%;
  align-items: center;
  justify-content: center;
  height: 2.375rem;
  margin-right: -50%;
  padding: 0 2rem;
  transform: translate(-50%, -50%);
  border: 1px solid #000;
  border-radius: 45px;
  color: #000;
  font-size: 0.8125rem;
  font-weight: bold;
  letter-spacing: 0.08em;
  line-height: 0;
  text-decoration: none;
  text-transform: uppercase;
  background: transparent;
  transition: all 0.2s ease-in;

  &.white {
    border: 1px solid #fff;
    color: #fff;

    &:hover {
      background: #fff;
      color: #000;
    }
  }

  &.black-full {
    border: 1px solid #000;
    background: #000;
    color: #fff;

    &:hover {
      border: 1px solid #fff;
      background: #fff;
      color: #000;
    }
  }

  &.white-full {
    background: #fff;
    color: #000;
    border: 1px solid #fff;

    &:hover {
      border: 1px solid #000;
      background: #000;
    }
  }

  &:hover {
    background: #000;
    color: #fff;
  }
}

.tablet .cta-btn-header {
  bottom: 2.25rem;
}

.header {
  position: relative;
}

// searchbar
$input-height: 50px;
$box-shadow-light: 0 1px 2px 0 rgba(0, 0, 0, 0.02),
  0 2px 1px -2px rgba(0, 0, 0, 0.02), 0 1px 3px 0 rgba(0, 0, 0, 0.05);
.bottom-bar {
  position: absolute;
  z-index: 1;
  width: 100%;
}
.search-input-container {
  display: flex;
  position: relative;
  top: -$input-height / 2;
  align-items: center;
  width: calc(100% - 20px);
  max-width: calc(768px - 32px);
  height: $input-height;
  margin: 0 auto;
}

.submit-search {
  display: block;
  display: flex;
  position: absolute;
  z-index: 2;
  top: 0;
  right: 5px;
  align-items: center;
  justify-content: space-around;
  min-width: 50px;
  height: $input-height;
  border: 0;
  border-radius: 15px;
  fill: #464646;
  cursor: pointer;

  i {
    font-size: 26px;
  }
}

.search-input {
  display: block;
  position: relative;
  z-index: 2;
  width: 100%;
  height: $input-height;
  padding: 15.2px 49px 15.2px 56px;
  border: 0;
  border-radius: 1px;
  border-radius: $input-height / 2;
  border-radius: 15px;
  background-image: url("http://images.samsung.com/is/image/samsung/p5/nl/welcome/google-logo-focused.png?$ORIGIN_PNG$");
  background-repeat: no-repeat;
  background-position: left 16px center;
  background-size: auto 45%;
  box-shadow: $box-shadow-light;
  font-size: 16px;
  &::placeholder {
    color: grey;
  }
}

.date-time {
  display: flex;
  justify-content: space-between;

  .field {
    width: 49%;
  }
}

//header icons
.top-bar {
  display: flex;
  z-index: 1;
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  align-items: center;
  justify-content: space-between;
  max-width: 750px;
  margin: 0 auto;
  padding: 15px 15px 0 15px;

  &.black {
    .settings-button,
    .s-logo {
      fill: #000;
    }
  }

  &.white {
    .settings-button,
    .s-logo {
      fill: #fff;
    }
  }
}

.settings-button {
  position: relative;
  padding: 0;
  border: 0;
  background: none;
  cursor: pointer;
}

.s-logo {
  height: 14px;
  padding: 0;
  cursor: pointer;
}
</style>

